import { ScrollReveal } from "./ScrollReveal";

export const About = () => {
  return (
    <section id="o-nas" className="py-24 md:py-32 bg-gradient-to-b from-white to-gray-50/50">
      <div className="container">
        <ScrollReveal>
          <h2 className="section-heading">
            O <span className="gradient-text">nas</span>
          </h2>
        </ScrollReveal>
        <ScrollReveal delay={0.2}>
          <div className="max-w-4xl mx-auto">
            <div className="glass-card rounded-3xl p-10 md:p-14 space-y-6">
              <p className="text-lg leading-relaxed text-gray-700">
                Jesteśmy zespołem profesjonalnych komików z wieloletnim doświadczeniem scenicznym. 
                Specjalizujemy się w występach komediowych dla firm, które nie tylko bawią, ale także integrują zespół 
                i budują pozytywną atmosferę w miejscu pracy.
              </p>
              <p className="text-lg leading-relaxed text-gray-700">
                Nasze występy są zawsze dopasowane do charakteru firmy i potrzeb klienta. 
                Łączymy profesjonalizm z humorem, tworząc niezapomniane wydarzenia, które na długo pozostają w pamięci uczestników.
              </p>
              <p className="text-lg leading-relaxed text-gray-700">
                Działamy na terenie całej Polski, zapewniając najwyższą jakość usług i gwarancję zadowolenia klientów.
              </p>
            </div>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
};
